export const ASIDENAV_WIDTH = '9rem';
export const ZINDEX_PORTAL = 9998;
export const ZINDEX_TOAST = 9999;
export const CARD_BASE_HEADER_HEIGHT = '6rem';
export const CARD_BASE_HEADER_MARGIN_BOTTOM = '2.4rem';
export const CARD_BASE_FOOTER_PADDING = '2rem';
export const PADDING_CARD = '3rem';
export const PLATFORM_LANGUAGES = ['en', 'es', 'pt'];
